/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import ClientsRowQuotes from '../components/ClientsRowQuotes'
import ClientsRowPolicies from '../components/ClientsRowPolicies'
import VariationsDropdown from '../components/VariationsDropdown'
import PopUp from '../../../common/PopUp/PopUp'
// import Mta from './MtaPopUp'

/**
 * ClientsTable class which will contain all the rows of the Quotes and Policies
 *
 * @export
 * @class ClientsTable
 * @extends {React.Component<any, any>}
 */
export default class ClientsTable extends React.Component<any, any> {

    /**
     * Creates an instance of ClientsTable.
     * @param {*} props
     * @memberof ClientsTable
     */
    constructor(props: any) {
        super(props)
        this.state = {
            viewQuotePopUp: false,
            editQuoteId: '',
            mtaQuoteId: '',
            addMtaPopUp: false,
            quotes: [],
            policies: [],
            noOverflow: false,
        }
    }

    /**
     * Will update the parent's data before the component mounts
     *
     * @memberof ClientsTable
     */
    componentWillMount() {
        if (this.props.updateData) {
            this.props.updateData('Quotes', this.state.quotes)
            this.props.updateData('Policies', this.state.policies)
        }

        if (this.props.clientList.quoteList && this.props.clientList.policyList) {
            this.setState(
                {
                    quotes: this.props.clientList.quoteList.quotes,
                    policies: this.props.clientList.policyList.policies,
                }
            )

        }
    }

    componentWillUpdate(nextProps: any) {
        if (nextProps.clientList.quoteList &&
            (nextProps.clientList.quoteList.quotes !== this.state.quotes)) {

            this.setState({ quotes: nextProps.clientList.quoteList.quotes })
            if (this.props.updateData) {
                this.props.updateData('Quotes', nextProps.clientList.quoteList.quotes)
            }
        }

        if (nextProps.clientList.policyList &&
            (nextProps.clientList.policyList.policies !== this.state.policies)) {
            this.setState({ policies: nextProps.clientList.policyList.policies })
            if (this.props.updateData) {
                this.props.updateData('Policies', nextProps.clientList.policyList.policies)
            }
        }
    }

    /**
     * Will open or close the item of the row
     *
     * @memberof ClientsTable
     * @param element the element selected
     */
    openCloseItem = (element) => {
        if (element.target.classList.contains('column__dropdown')) {
            if (element.target.classList.contains('active')) {
                element.target.parentNode.classList.remove('active')
                element.target.parentNode.nextSibling.classList.remove('active')
                element.target.classList.remove('active')
            } else if (element.target.classList.contains('column__dropdown')) {
                element.target.parentNode.classList.add('active')
                element.target.parentNode.nextSibling.classList.add('active')
                element.target.classList.add('active')
            }
        }
    }

    /**
     * Will show the edit quote PopUp
     *
     * @memberof ClientsTable
     */
    viewQuoteClick = (id: any) => {
        this.setState({ viewQuotePopUp: !this.state.viewQuotePopUp, editQuoteId: id })
    }

    /**
     * Will show the edit mta PopUp
     *
     * @memberof ClientsTable
     */
    addMtaClick = (mtaId: any) => {
        this.setState({ addMtaPopUp: !this.state.addMtaPopUp, mtaQuoteId: mtaId })
    }

    /**
     * Will close the edit mta PopUp
     *
     * @memberof ClientsTable
     */
    addMtaClose = () => {
        this.setState({ addMtaPopUp: false })
    }

    /**
     * Will add MTA
     *
     * @memberof ClientsTable
     */
    addMtaContinue = () => {
        this.props.history.push('/clients/policies/mta/' + this.state.mtaQuoteId)
    }

    editQuoteAction = () => {
        this.props.confirmEditQuote(this.state.editQuoteId)
        this.props.history.push('/clients/quotes/edit/' + this.state.editQuoteId)
    }

    render() {
        return (
            <div>
                {(this.state.viewQuotePopUp) ?
                    <PopUp
                        title="Do you wish to edit this quote?"
                        action={this.editQuoteAction}
                        buttonText="Edit quote"
                        secondaryAction={() => { this.viewQuoteClick('') }}
                        secondaryButtonText="Cancel"
                    >
                        If you edit this quote the other preview quotes you have issued for this client will be revoked.
                        Do you wish to continue?
                    </PopUp>
                    : null}
                {(this.state.addMtaPopUp) ?
                    <div className="addMta">
                        <PopUp
                            title="Add Mid Term Adjustment"
                            action={() => { this.addMtaContinue() }}
                            buttonText="Continue"
                            secondaryAction={() => { this.addMtaClose() }}
                            secondaryButtonText="Cancel"
                        >
                            <div style={{ padding: 20 }}>
                                Are you sure you want to add an MTA?
                            </div>
                        </PopUp>
                    </div>
                    : null}
                {(this.props.dataType === 'quotes' && this.state.quotes) ?
                    (this.state.quotes.map((quote: any, i: number) => (
                        <div key={i} className={`quoteListRow ${this.state.noOverflow ? 'noOverflow' : ''}`}>
                            <ClientsRowQuotes
                                quote={quote}
                                action={this.openCloseItem}
                                openPopUp={this.viewQuoteClick}
                            />
                            <VariationsDropdown
                                quote={quote}
                                subjectivity={quote.subjectivity}
                                variations={quote.quoteVariations}
                                bindClick={
                                    (quoteObject, variationObject) => this.props.bindClick(quoteObject, variationObject)
                                }
                                noOverflow={(state) => this.setState({ noOverflow: state })}
                            />
                        </div>
                    )
                    )) :
                    (
                        (this.state.policies) ?
                            (this.state.policies.map((policy: any, i: number) => (
                                <div key={i} className="policiesListRow">
                                    <ClientsRowPolicies
                                        quote={policy}
                                        action={this.openCloseItem}
                                        manageAgency={this.props.manageAgency}
                                        openPopUp={(mtaId) => this.addMtaClick(mtaId)}
                                    />
                                </div>
                            ))
                            ) : null
                    )

                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Clients/components/ClientsTable.tsx